import { RgDataSetID } from "@project-rouge/rg-core";
import { RewindPolygonAnticlockwise } from "src/utils/RewindPolygonAnticlockwise";
import { World } from "src/types/World";
import { Zone } from "src/types/Zone";

// Construct a minimal World the design generator can consume: one Site
// (auto-wrapped on world.addZone), one Zone with an axis-aligned box
// footprint (length × width — square if equal), and a brief overridden to
// "1 building, N residential floors". UnitMix stays at the dataset default.
// The aggregator generates plots + buildings itself from the zone brief —
// we don't pre-populate them.
//
// Polygon must be wound anticlockwise. The production canvas-drawing flow at
// CreateMode.tsx:86 always rewinds before setOuterRing; the aggregator
// silently produces empty designs (and exhausts maxInvalidations) if given a
// clockwise polygon.
//
// `datasetId` is optional — when omitted the World falls back to its default
// (Dataset.id, currently uk_01), preserving existing callers (cost-tracking,
// module-explorer Section B). Pass it to drive generation on a non-default
// dataset (e.g. uk_02).
export function CreateBoxWorld(
  length: number,
  width: number,
  floors: number,
  datasetId?: RgDataSetID
): World {
  const world = new World(datasetId ? { rgDatasetId: datasetId } : undefined);
  const zone = new Zone();
  const ring = RewindPolygonAnticlockwise([
    [0, 0, 0],
    [length, 0, 0],
    [length, 0, width],
    [0, 0, width],
  ]);
  zone.setOuterRing(ring);
  zone.brief.buildingCount = 1;
  zone.brief.setResidentialFloorCount(floors);
  world.addZone(zone);
  return world;
}
